import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { STEPS } from "@/lib/site";

export default function ThreeSteps() {
  return (
    <section data-testid="three-steps" className="relative py-20 md:py-28">
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-16 items-end">
          <div className="col-span-12 md:col-span-7">
            <span className="chip mb-5">
              <span className="dot" /> Cómo entras al programa
            </span>
            <h2 className="font-display text-3xl md:text-5xl lg:text-[56px] font-bold text-[#0B0B14] tracking-tight leading-[1.05]">
              Cambiar proveedor no es difícil. Es una <span className="text-[#5A48C9]">decisión de 15 minutos.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 flex md:justify-end">
            <a
              data-testid="steps-cta"
              href="#contacto"
              className="btn-pill btn-primary shine"
            >
              Solicitar evaluación
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9 }}
          className="card-glass p-10 md:p-16 text-center"
        >
          <ul className="space-y-4 md:space-y-6">
            {STEPS.map((s, i) => (
              <motion.li
                key={s.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.12 }}
                data-testid={`step-${s.n}`}
                className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#0B0B14] tracking-tight"
              >
                {s.text}
              </motion.li>
            ))}
          </ul>

          <div className="mt-10 md:mt-12 flex justify-center">
            <a
              data-testid="steps-inner-cta"
              href="#portafolio"
              className="btn-pill btn-outline text-[15px] px-6 py-3.5"
            >
              Ver los 3 fillers
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
